function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(0 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 9,
  rx: 0,
  ry: 0,
  width: 6,
  height: 20,
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.875s",
  repeatCount: "indefinite"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(45 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 9,
  rx: 0,
  ry: 0,
  width: 6,
  height: 20,
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.75s",
  repeatCount: "indefinite"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(90 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 9,
  rx: 0,
  ry: 0,
  width: 6,
  height: 20,
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.625s",
  repeatCount: "indefinite"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(135 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 9,
  rx: 0,
  ry: 0,
  width: 6,
  height: 20,
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.5s",
  repeatCount: "indefinite"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(180 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 9,
  rx: 0,
  ry: 0,
  width: 6,
  height: 20,
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.375s",
  repeatCount: "indefinite"
})));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(225 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 9,
  rx: 0,
  ry: 0,
  width: 6,
  height: 20,
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.25s",
  repeatCount: "indefinite"
})));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(270 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 9,
  rx: 0,
  ry: 0,
  width: 6,
  height: 20,
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.125s",
  repeatCount: "indefinite"
})));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(315 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 9,
  rx: 0,
  ry: 0,
  width: 6,
  height: 20,
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "0s",
  repeatCount: "indefinite"
})));

function SvgButtonSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      display: "block",
      shapeRendering: "auto"
    },
    width: "30px",
    height: "30px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonSpinner);
export default __webpack_public_path__ + "static/media/button-spinner.8c500ee3.svg";
export { ForwardRef as ReactComponent };